import { apiGetProductData } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setCurrentProduct } from "../../actionCreators/makeActionCreator";
const LoadCurrentProductThunk = (currentProduct) => async (dispatch) => {
    try {
        const data = await apiGetProductData(currentProduct);
        dispatch(setCurrentProduct(data));
    }
    catch (e) {
        toastService.errorMessage(e);
    }
};
export default LoadCurrentProductThunk;
